import type { AuthUseCaseError } from "~application/auth/errors/auth-errors.ts";
import type { AUTHENTICATION_FRENCH_LOCALE } from "~ui/@application/locales/modules/authentication/authentication.fr.ts";

const loginToastErrors: Record<AuthUseCaseError["kind"], { title: string; details: string }> = {
  InvalidCredentials: {
    title: "Incorrect credentials",
    details: "The email or password you entered is incorrect. Please check your details and try again.",
  },
  UnexpectedError: {
    title: "Something went wrong",
    details:
      "An unexpected error occurred. Please try again in a moment. If the issue continues, check your internet connection.",
  },
  TransportError: {
    title: "Server error",
    details: "We received an invalid response from the server. Please try again later.",
  },
  NotAuthenticated: {
    title: "Server error",
    details: "We received an invalid response from the server. Please try again later.",
  },
  ForbiddenByPolicy: {
    title: "Forbidden",
    details: "You are not allowed to access to this application.",
  },
};

export const AUTHENTICATION_ENGLISH_LOCALE = {
  connectToVoltexploit: "Connect to your account",
  username: "Username",
  password: "Password",
  loginBtn: "Log in",
  placeholders: {
    username: "john.doe@voltalis.com",
    password: "Password",
  },
  errors: {
    toasts: {
      login: loginToastErrors,
    },
  },
} satisfies typeof AUTHENTICATION_FRENCH_LOCALE;
